import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  getItemPurchase,
  getItemPurchaseorderDetail,
  uploadInvoice,
  postGeneralData,
  UpdatePaymentComplete,
  deleteItemPurchase,
  createItemPurchaseReturn,
  getItemPurchaseReturns
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, DocumentViewerModal } from "../../Common/Functions";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getFormattedCurrentDate2,
  isReadonlyRoute,
  NaviGate,
  onReqCreatePayment,
  shop_id,
} from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";

const ItemPurchase = () => {
  const navigate = useNavigate();
  const { selectedWarehouse, showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
  const [user, setuser] = useState(UserItem)
  const [Purchase, setPurchase] = useState([]);
  const [PO_Data, setPO_Data] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [Paymentvalue, setPaymentvalue] = useState();
  const [pamentsModel, setpamentsModel] = useState(false);
  const [payAmount, setPayAmount] = useState(0);
  const [remainingCapital, setRemainingCapital] = useState(0);
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchText, setSearchText] = useState("");
  const [resetDone, setResetDone] = useState(false);

  // --- Purchase Delete State ---
  const [showdeleteModal, setShowdeleteModal] = useState(false);
  const [showdeleteID, setShowdeleteID] = useState("");

  // --- Purchase Return State ---
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnPurchase, setReturnPurchase] = useState(null);
  const [returnItems, setReturnItems] = useState([]);
  const [returnQtys, setReturnQtys] = useState({});
  const [returnReason, setReturnReason] = useState("");
  const [returnRefundType, setReturnRefundType] = useState("payable_reduction"); // "bank" or "payable_reduction"
  const [globalPurchaseReturns, setGlobalPurchaseReturns] = useState([]);

  const getPurchaseReturnedAmount = (po) => {
    let totalReturned = 0;
    globalPurchaseReturns.forEach((ret) => {
      if (ret.unique_id && ret.unique_id.includes(po)) {
        const amt = parseFloat(ret.amount || 0) + parseFloat(ret.credit_adjustment || 0);
        totalReturned += amt;
      }
    });
    return totalReturned;
  };

  useEffect(() => {
    fetchPurchase();
  }, []);

  useEffect(() => {
    if (resetDone) {
      fetchPurchase(1, "");
      setResetDone(false);
    }
  }, [resetDone]);

  const fetchPurchase = async (page = 1, text = "") => {
    try {
      showLoader();
      const filters = {
        start_date: fromDate,
        end_date: toDate,
      };
      const shopIdVal = shopItem?.shop_id || shopItem?.id || shop_id;
      const [response, returnsRes] = await Promise.all([
        getItemPurchase(page, text, 1, shopIdVal, filters),
        getItemPurchaseReturns().catch((e) => {
          console.error("Error fetching purchase returns list:", e);
          return { data: { data: [] } };
        })
      ]);
      if (response.data && response.data.data) {
        setPurchase(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        setRemainingCapital(response.data.remain_capital);
      }
      if (returnsRes?.data && returnsRes.data.data) {
        setGlobalPurchaseReturns(returnsRes.data.data);
      }
      hideLoader();
    } catch (error) {
      console.error("Error fetching Item Purchase data:", error);
      toast.error("Error fetching Item Purchases");
      hideLoader();
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    if (fromDate && !toDate) {
      toast.error("Please select To date ");
      return;
    }
    if (toDate && !fromDate) {
      toast.error("Please select From Date");
      return;
    }
    fetchPurchase();
  };

  const resetFilter = () => {
    setFromDate("");
    setToDate("");
    setSearchText("");
    setResetDone(true);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchPurchase(pageNumber);
  };

  const handleSearch = async (text) => {
    if (text.length > 3 || text.length === 0) {
      setCurrentPage(1);
      fetchPurchase(1, text);
    }
  };

  const [documentModal, setDocumentModal] = useState(false);
  const [DocumentUrl, setDocumentUrl] = useState("");

  const openDocumentView = (viewer) => {
    const Url = `http://193.203.162.101:8002/media/${viewer}`;
    setDocumentUrl(Url);
    setDocumentModal(true);
  };

  const [isOrderModal, setOrderModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [selectedOrderData, setSelectedOrderData] = useState();
  const [selectedOrderItems, setSelectedOrderItems] = useState([]);

  const handleGetPurchaseOrder = async (state) => {
    try {
      showLoader();
      const response = await getItemPurchaseorderDetail(state.po);
      hideLoader();

      let payments = [];
      if (response.data && response.data.payment) {
        payments = response.data.payment;
      }
      let items = [];
      if (response.data && response.data.data) {
        items = response.data.data;
      }

      setSelectedOrderData(state);
      setSelectedOrder(payments);
      setSelectedOrderItems(items);
      setOrderModal(true);
    } catch (error) {
      hideLoader();
      console.error("Error fetching order details:", error);
      toast.error("Error fetching purchase details");
    }
  };

  const [cashAmount, setCashAmount] = useState("");
  const [cardAmount, setCardAmount] = useState("");
  const dueAmount = parseFloat(Paymentvalue?.remaining || 0);
  const totalPayment =
    parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0);
  const remainingAmount = dueAmount - totalPayment;

  const Handlepaymentmodel = async (item) => {
    setPayAmount(0);
    setCashAmount(0);
    setCardAmount(0);
    setPaymentvalue(item);
    setpamentsModel(true);
  };

  const handleCashChange = (e) => {
    let value = e.target.value;
    if (value === "") {
      setCashAmount("");
      return;
    }
    if (!/^\d*(\.\d*)?$/.test(value)) return;
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue + parseFloat(cardAmount || 0) > dueAmount) return;
    setCashAmount(value);
  };

  const handleCardChange = (e) => {
    let value = e.target.value;
    if (value === "") {
      setCardAmount("");
      return;
    }
    if (!/^\d*(\.\d*)?$/.test(value)) return;
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue + parseFloat(cashAmount || 0) > dueAmount) return;
    setCardAmount(value);
  };

  const onHandlePayCredit = async (cashAmount, cardAmount) => {
    try {
      showLoader();
      if (!Paymentvalue?.purchase_id) {
        toast.error("Invalid purchase details");
        hideLoader();
        return;
      }

      const cash = parseFloat(cashAmount || 0);
      const card = parseFloat(cardAmount || 0);

      var paydata = {
        orderID: Paymentvalue?.po,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: Paymentvalue.total,
        cash: cash,
        credit: 0,
        card: card,
        type: 1, // Purchase type
        mop: "0",
        complete: "0",
      };

      if (cashAmount && cardAmount) {
        paydata.cash = cashAmount;
        paydata.card = cardAmount;
        paydata.mop = "1,4";
        paydata.complete = "1";
      } else if (cashAmount) {
        paydata.cash = cashAmount;
        paydata.mop = "1";
        paydata.complete = "1";
      } else if (cardAmount) {
        paydata.card = cardAmount;
        paydata.mop = "4";
        paydata.complete = "1";
      }
      if (remainingAmount > 0) {
        paydata.credit = remainingAmount;
        paydata.mop = paydata.mop + ",2";
        paydata.complete = "0";
      }
      await onReqCreatePayment(paydata);
      try {
        const generalDataPayload1 = {
          type: "2",
          ref_id: Paymentvalue?.po,
          remarks: "Bank - To purchase",
          date: getFormattedCurrentDate2(),
          created_by: user?.user_id,
          shop_id: shopItem?.id || "0",
          amount: parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0),
          is_debit: "0",
        };
        await postGeneralData(generalDataPayload1);

        if (paydata?.complete === "0") {
          const generalDataPayload = {
            type: "7",
            ref_id: Paymentvalue?.po,
            remarks: "Purchase Credit",
            date: getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: remainingAmount,
            is_debit: "0",
          };
          await postGeneralData(generalDataPayload);
        } else {
          const paymentCompleted = {
            type: "7",
            shop_id: shopItem?.id || "0",
            ref_id: Paymentvalue?.po,
          }
          await UpdatePaymentComplete(paymentCompleted);
        }
      } catch (e) {
        console.error("General log failed:", e);
        toast.error("Failed to create general transaction log");
      }
      toast.success("Payment successfully");
      await fetchPurchase(currentPage);
      setpamentsModel(false);
      setPayAmount(0);
      setCashAmount(0);
      setCardAmount(0);
      hideLoader();
    } catch (error) {
      console.error("Error updating payment:", error);
      toast.error("Error processing payment. Please try again.");
      hideLoader();
    }
  };

  const fileInputRef = useRef(null);
  const [po_id, setpo_id] = useState();

  const handleButtonClick = (data) => {
    setpo_id(data.po);
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("po_id", po_id);
    formData.append("file", file);

    try {
      await uploadInvoice(formData);
      toast.success("Invoice uploaded.");
      await fetchPurchase();
    } catch (error) {
      console.error("Upload Error:", error);
    }
  };

  const handleDelete = async () => {
    try {
      showLoader();
      await deleteItemPurchase(showdeleteID);
      toast.success("Item Purchase deleted successfully");
      fetchPurchase(currentPage);
      setShowdeleteModal(false);
    } catch (error) {
      console.error("Error deleting Purchase:", error);
      toast.error("Failed to delete item purchase");
    } finally {
      hideLoader();
    }
  };

  // --- Purchase Return Functions ---
  const handleOpenReturn = async (purchase) => {
    try {
      showLoader();
      const response = await getItemPurchaseorderDetail(purchase.po);
      hideLoader();

      let items = [];
      if (response.data && response.data.data) {
        items = response.data.data;
      }

      setReturnPurchase(purchase);
      setReturnItems(items);
      setReturnQtys({});
      setReturnReason("");
      setReturnRefundType("payable_reduction"); // Default to reducing supplier payable
      setShowReturnModal(true);
    } catch (error) {
      hideLoader();
      console.error("Error fetching purchase details:", error);
      toast.error("Error fetching purchase details for return");
    }
  };

  const handleReturnQtyChange = (itemId, val, maxQty) => {
    let num = parseFloat(val);
    if (isNaN(num) || num < 0) num = 0;
    if (num > maxQty) num = maxQty;
    num = Math.round(num * 1000) / 1000;
    setReturnQtys((prev) => ({
      ...prev,
      [itemId]: num
    }));
  };

  const calcReturnFinancials = () => {
    let totalReturn = 0;
    returnItems.forEach(it => {
      const q = returnQtys[it.id] || 0;
      const price = parseFloat(it.unit_price || it.purchase_price || it.price || 0);
      totalReturn += q * price;
    });

    const payableBalance = parseFloat(returnPurchase?.remaining || 0);

    let creditAdjust = 0; // Amount of payable to reduce
    let refundAmount = 0; // Amount we need back in Bank
    let newPayable = payableBalance;

    if (totalReturn <= payableBalance) {
      creditAdjust = totalReturn;
      refundAmount = 0;
      newPayable = payableBalance - totalReturn;
    } else {
      creditAdjust = payableBalance;
      refundAmount = totalReturn - payableBalance;
      newPayable = 0;
    }

    return { totalReturn, payableBalance, creditAdjust, refundAmount, newPayable };
  };

  const handleSubmitReturn = async () => {
    const fin = calcReturnFinancials();
    if (fin.totalReturn <= 0) {
      toast.warning("Please select items to return");
      return;
    }

    try {
      showLoader();
      const sales_update = returnItems.map(it => {
        const retQ = returnQtys[it.id] || 0;
        return {
          id: it.id,
          serial_number: "RETURN",
          return_qty: retQ
        };
      }).filter(it => it.return_qty > 0);

      const shopIdVal = shopItem?.shop_id || shopItem?.id || shop_id;

      const payload = {
        unique_id: `RET-PO-${returnPurchase.po}-${Date.now()}`,
        amount: fin.refundAmount,
        credit_adjustment: fin.creditAdjust,
        po_id: returnPurchase.po,
        po_number: returnPurchase.po,
        refund_type: returnRefundType,
        reason: returnReason,
        supplier_id: returnPurchase.supplier_id,
        sales_update: JSON.stringify(sales_update),
        shop_id: shopIdVal,
        user_id: user?.user_id || user?.id,
        serial_number: "[]"
      };

      const res = await createItemPurchaseReturn(payload);
      hideLoader();

      if (res.data?.status === "success" || res.status === 201 || res.status === 200) {
        toast.success("Item purchase return processed successfully!");
        setShowReturnModal(false);
        fetchPurchase(currentPage);
      } else {
        toast.error(res.data?.message || "Failed to process return");
      }
    } catch (error) {
      hideLoader();
      console.error("Error processing return:", error);
      toast.error(error.response?.data?.message || "Error processing return");
    }
  };

  return (
    <>
      <div className="page-wrappers">
        <div className="page-content">
          <NaviGate />
          <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded-2xl border border-slate-100 shadow-sm">
            <div className="text-start">
              <h3 className="mb-1 fw-bold text-slate-800 tracking-tight" style={{ fontSize: "24px" }}>Item Purchases</h3>
              <p className="text-sm text-slate-500 mb-0 font-medium">Record and manage purchases of generic items</p>
            </div>
            {!readonly && (
              <div className="d-flex gap-2">
                <button
                  type="button"
                  onClick={() => navigate("/add_item_purchase")}
                  className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 font-semibold text-sm"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                  New Item Purchase
                </button>
              </div>
            )}
          </div>

          <hr className="mt-1" />

          <div className="card border-0 shadow-sm rounded-2xl">
            <div className="card-body p-4">
              <div className="col-12 mb-3 mb-md-2">
                <div className="container-fluid">
                  <div className="row align-items-end g-2">
                    {/* From Date */}
                    <div className="col-6 col-md-2">
                      <div className="text-start">
                        <label className="form-label mb-1" style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>From Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={fromDate}
                          max={toDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* To Date */}
                    <div className="col-6 col-md-2">
                      <div className="text-start">
                        <label className="form-label mb-1" style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>To Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={toDate}
                          min={fromDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* Purchase ID Search */}
                    <div className="col-6 col-md-2">
                      <div className="text-start">
                        <label className="form-label mb-1" style={{ fontSize: "14px", color: "#64748b", fontWeight: "500" }}>Purchase ID</label>
                        <input
                          type="text"
                          className="form-control"
                          value={searchText}
                          onChange={(e) => {
                            setSearchText(e.target.value);
                            handleSearch(e.target.value);
                          }}
                          placeholder="Search by ID"
                        />
                      </div>
                    </div>

                    {/* Filter & Reset Buttons */}
                    <div className="col-12 col-md-3 mb-2 mb-md-0 d-flex align-items-end gap-2">
                      <button
                        type="submit"
                        onClick={handleFilter}
                        className="btn btn-primary btn-sm px-3 py-1.5 w-auto"
                        style={{ fontSize: "0.85rem", minWidth: "90px", height: "38px" }}
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        onClick={resetFilter}
                        className="btn btn-secondary btn-sm px-3 py-1.5 w-auto"
                        style={{ fontSize: "0.85rem", minWidth: "90px", height: "38px" }}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table
                  className="table table-hover table-align-middle text-center mb-4"
                  style={{ width: "100%", fontFamily: "Poppins" }}
                >
                  <thead className="table-light">
                    <tr>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Purchase #</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Supplier</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Total</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Paid</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Status</th>
                      <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Invoice</th>
                      {!readonly && <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {Purchase.length > 0 ? (
                      Purchase.map((item, index) => {
                        const total = parseFloat(item.grand_total !== undefined && item.grand_total !== null ? item.grand_total : item.total || 0);
                        const remaining = parseFloat(item.remaining !== undefined ? item.remaining : total);
                        const paid = item.purchase_unit === "1" || item.purchase_unit === 1 ? total : (total - remaining);
                        return (
                          <tr key={item.purchase_id || index} className="align-middle border-bottom border-slate-100">
                            <td className="text-sm font-semibold text-slate-700 py-3">{item.po}</td>
                            <td className="text-sm text-slate-600" style={{ maxWidth: "200px", whiteSpace: "normal", overflowWrap: "break-word" }}>{item.supplier_name}</td>
                            <td className="text-sm text-slate-600">{item.date}</td>
                            <td className="text-sm font-semibold text-slate-700">{total.toFixed(3)} INR</td>
                            <td className="text-sm font-semibold text-slate-700">{paid.toFixed(3)} INR</td>
                            <td>
                              {(item.purchase_unit === "1" || item.purchase_unit === 1 || paid >= total) ? (
                                <span className="badge px-2.5 py-1 text-xs font-bold uppercase rounded-full" style={{ backgroundColor: "#ecfdf5", color: "#10b981" }}>
                                  Paid
                                </span>
                              ) : (
                                <span className="badge px-2.5 py-1 text-xs font-bold uppercase rounded-full" style={{ backgroundColor: "#fff7ed", color: "#f97316" }}>
                                  Pending
                                </span>
                              )}
                            </td>
                            <td>
                              {item.file ? (
                                <button
                                  className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 mx-auto justify-content-center"
                                  onClick={() => openDocumentView(item.file)}
                                >
                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-blue-600"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /></svg>
                                  <span className="text-xs font-semibold text-blue-600">View</span>
                                </button>
                              ) : (
                                <button
                                  className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 mx-auto justify-content-center text-slate-400"
                                  onClick={() => handleButtonClick(item)}
                                >
                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-400"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
                                  <span className="text-xs font-medium text-slate-400">Upload</span>
                                </button>
                              )}
                            </td>
                            {!readonly && (
                              <td>
                                <div className="d-flex align-items-center gap-3 justify-content-center">
                                  <button
                                    className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 text-slate-600 hover:text-blue-600"
                                    onClick={() => handleGetPurchaseOrder(item)}
                                    title="View"
                                  >
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-500"><circle cx="12" cy="12" r="3" /><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /></svg>
                                  </button>
                                  <button
                                    className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 text-danger hover:text-red-700"
                                    onClick={() => handleOpenReturn(item)}
                                    title="Return"
                                  >
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                      <polyline points="9 22 9 12 15 12 15 22" />
                                    </svg>
                                  </button>
                                  {getPurchaseReturnedAmount(item.po) === 0 && (
                                    <button
                                      className="btn btn-link p-0 text-decoration-none d-flex align-items-center gap-1 text-danger hover:text-red-700"
                                      onClick={() => {
                                        setShowdeleteID(item.id);
                                        setShowdeleteModal(true);
                                      }}
                                      title="Delete"
                                    >
                                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              </td>
                            )}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center text-slate-400 py-4">
                          No purchases found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                {totalPages > 1 && (
                  <div className="pagination mb-1">
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      className={`page-link text-normal rounded-1 ${currentPage === 1 ? "disabled" : ""}`}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>

                    {Array.from({ length: totalPages }, (_, index) => (
                      <button
                        key={index + 1}
                        onClick={() => handlePageChange(index + 1)}
                        className={`page-link text-normal rounded-1 ${currentPage === index + 1 ? "active" : ""}`}
                      >
                        {index + 1}
                      </button>
                    ))}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      className={`page-link text-normal rounded-1 ${currentPage === totalPages ? "disabled" : ""}`}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {documentModal && (
        <DocumentViewerModal
          setShowModal={setDocumentModal}
          documentUrl={DocumentUrl}
        />
      )}

      {showdeleteModal && (
        <Deletemodel
          setShowModal={setShowdeleteModal}
          handleDelete={handleDelete}
        />
      )}

      {/* Process Return Modal */}
      {showReturnModal && returnPurchase && (() => {
        const fin = calcReturnFinancials();
        return (
          <div
            className="modal fade show"
            style={{ display: "block", background: "rgba(0,0,0,0.55)", zIndex: 1060 }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
              <div className="modal-content" style={{ borderRadius: "14px", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>
                
                {/* Header */}
                <div className="modal-header" style={{ background: "linear-gradient(135deg, #10b981 0%, #047857 100%)", borderRadius: "14px 14px 0 0" }}>
                  <div>
                    <h5 className="modal-title text-white fw-bold mb-0">
                      🔄 Process Item Purchase Return
                    </h5>
                    <small className="text-white opacity-75">
                      Purchase PO: {returnPurchase?.po} &nbsp;|&nbsp; Supplier: {returnPurchase?.supplier_name}
                    </small>
                  </div>
                  <button type="button" className="btn-close btn-close-white" onClick={() => setShowReturnModal(false)} />
                </div>

                {/* Body */}
                <div className="modal-body p-4 text-start">
                  <h6 className="fw-bold mb-3 text-dark">Select Items to Return</h6>
                  {returnItems.length === 0 ? (
                    <div className="text-center text-muted py-4">No items found for this purchase.</div>
                  ) : (
                    <div className="table-responsive mb-4">
                      <table className="table table-bordered table-sm align-middle text-center">
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th className="text-start">Item</th>
                            <th>Purchased Qty</th>
                            <th>Remaining Qty</th>
                            <th>Unit Price</th>
                            <th>Return Qty</th>
                            <th className="text-end">Return Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {returnItems.map((it, idx) => {
                            const boughtQty = parseFloat(it.qty || 0);
                            const alreadyRet = parseFloat(it.return_qty || 0);
                            const totalQty = boughtQty + alreadyRet;
                            const retQty = returnQtys[it.id] || 0;
                            const price = parseFloat(it.unit_price || it.purchase_price || it.price || 0);
                            const retAmt = retQty * price;

                            return (
                              <tr key={it.id} className={retQty > 0 ? "table-warning" : ""}>
                                <td>{idx + 1}</td>
                                <td className="text-start fw-semibold">{it.product_name || `Item #${it.item_id}`}</td>
                                <td>{totalQty}</td>
                                <td className="fw-semibold text-primary">{boughtQty}</td>
                                <td>₹{price.toFixed(2)}</td>
                                <td style={{ width: "150px" }}>
                                  {boughtQty <= 0 ? (
                                    <span className="badge bg-danger">Fully Returned</span>
                                  ) : (
                                    <div className="d-flex align-items-center gap-1 justify-content-center">
                                      <button
                                        className="btn btn-outline-secondary btn-sm px-2 py-0"
                                        onClick={() => {
                                          const step = boughtQty <= 1 ? 0.01 : 1;
                                          const prevQty = Math.max(0, retQty - step);
                                          handleReturnQtyChange(it.id, prevQty.toString(), boughtQty);
                                        }}
                                      >−</button>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm text-center qty-input-no-spin"
                                        value={retQty}
                                        min={0}
                                        max={boughtQty}
                                        step="any"
                                        onChange={(e) => handleReturnQtyChange(it.id, e.target.value, boughtQty)}
                                      />
                                      <button
                                        className="btn btn-outline-secondary btn-sm px-2 py-0"
                                        onClick={() => {
                                          const step = boughtQty <= 1 ? 0.01 : 1;
                                          const nextQty = Math.min(boughtQty, retQty + step);
                                          handleReturnQtyChange(it.id, nextQty.toString(), boughtQty);
                                        }}
                                      >+</button>
                                    </div>
                                  )}
                                </td>
                                <td className="text-end fw-semibold">
                                  {retQty > 0 ? `₹${retAmt.toFixed(2)}` : "—"}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* Financial Summary */}
                  <div className="card border-0 mb-3" style={{ background: "#f8f9fa" }}>
                    <div className="card-body p-3">
                      <h6 className="fw-bold mb-3" style={{ color: "#047857" }}>Financial Summary</h6>
                      <div className="row g-2">
                        <div className="col-6">
                          <div className="d-flex justify-content-between border-bottom pb-2">
                            <span className="text-muted small">Total Return Value</span>
                            <span className="fw-bold">₹{fin.totalReturn.toFixed(2)}</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex justify-content-between border-bottom pb-2">
                            <span className="text-muted small">Current Supplier Payable</span>
                            <span className="fw-bold text-danger">₹{parseFloat(returnPurchase?.remaining || 0).toFixed(2)}</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex justify-content-between border-bottom pb-2">
                            <span className="text-muted small">Payable Adjusted</span>
                            <span className="fw-bold text-warning">−₹{fin.creditAdjust.toFixed(2)}</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex justify-content-between border-bottom pb-2">
                            <span className="text-muted small">Refund Amount (Receivable)</span>
                            <span className="fw-bold text-success">₹{fin.refundAmount.toFixed(2)}</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex justify-content-between">
                            <span className="text-muted small">New Payable Balance</span>
                            <span className="fw-bold text-primary">₹{fin.newPayable.toFixed(2)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Refund Type Toggle */}
                  {fin.refundAmount > 0 && (
                    <div className="mb-3">
                      <label className="fw-semibold mb-2 d-block">How to handle ₹{fin.refundAmount.toFixed(2)} receivable?</label>
                      <div className="d-flex gap-3">
                        <div
                          className={`flex-fill p-3 rounded border-2 cursor-pointer ${returnRefundType === "bank" ? "border border-success bg-success bg-opacity-10" : "border"}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setReturnRefundType("bank")}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <input type="radio" checked={returnRefundType === "bank"} onChange={() => setReturnRefundType("bank")} />
                            <div>
                              <div className="fw-bold small">Receive to Bank</div>
                              <div className="text-muted" style={{ fontSize: "11px" }}>Supplier pays cash back now</div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`flex-fill p-3 rounded border-2 cursor-pointer ${returnRefundType === "payable_reduction" ? "border border-primary bg-primary bg-opacity-10" : "border"}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setReturnRefundType("payable_reduction")}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <input type="radio" checked={returnRefundType === "payable_reduction"} onChange={() => setReturnRefundType("payable_reduction")} />
                            <div>
                              <div className="fw-bold small">Keep as Supplier Receivable</div>
                              <div className="text-muted" style={{ fontSize: "11px" }}>Use against future purchases</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Return Reason */}
                  <div className="mb-2">
                    <label className="fw-semibold mb-1 small">Return Reason <span className="text-muted">(optional)</span></label>
                    <textarea
                      className="form-control form-control-sm"
                      rows={2}
                      placeholder="e.g. Damaged product, wrong specification..."
                      value={returnReason}
                      onChange={(e) => setReturnReason(e.target.value)}
                    />
                  </div>

                </div>

                {/* Footer */}
                <div className="modal-footer border-0 pt-0">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowReturnModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-success fw-bold"
                    onClick={handleSubmitReturn}
                    disabled={fin.totalReturn === 0}
                  >
                    Confirm Return — ₹{fin.totalReturn.toFixed(2)}
                  </button>
                </div>

              </div>
            </div>
          </div>
        );
      })()}

      <div
        className="modal fade show"
        style={{ display: pamentsModel ? "block" : "none", background: "rgba(0,0,0,0.55)", zIndex: 1060 }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-3" style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}>
            <div className="modal-header border-0">
              <h5 className="modal-title fw-bold text-dark font-18">Payment</h5>
              <button type="button" className="btn-close" onClick={() => setpamentsModel(false)}></button>
            </div>

            <div className="modal-body text-start">
              <div className="p-3 bg-light rounded ">
                <p className="mb-2">Order ID: <span className="fw-bold">{Paymentvalue?.po}</span></p>
                <p className="mb-2">Supplier Name: <span className="fw-bold">{Paymentvalue?.supplier_name}</span></p>
                <hr />
                <div>
                  <p className="mb-2 d-flex justify-content-between">
                    <span>Amount:</span>
                    <span className="text-primary fw-bold">₹{parseFloat(Paymentvalue?.total || 0).toFixed(2)}</span>
                  </p>
                  <p className="mb-2 d-flex justify-content-between">
                    <span>Due Amount:</span>
                    <span className="text-danger fw-bold">₹{parseFloat(Paymentvalue?.remaining || 0).toFixed(2)}</span>
                  </p>
                  <p className="mb-2 d-flex justify-content-between align-items-center">
                    <span>Cash:</span>
                    <input
                      type="number"
                      className="form-control text-end w-25"
                      value={cashAmount}
                      onChange={handleCashChange}
                    />
                  </p>
                  <p className="mb-2 d-flex justify-content-between align-items-center">
                    <span>Card:</span>
                    <input
                      type="number"
                      className="form-control text-end w-25"
                      value={cardAmount}
                      onChange={handleCardChange}
                    />
                  </p>
                </div>
                <hr />
                <p className="mb-0 fw-bold fs-5 text-end">
                  Remaining Amount: <span className="text-success fw-bold">₹{remainingAmount.toFixed(2)}</span>
                </p>
              </div>
            </div>

            <div className="modal-footer border-0 d-flex justify-content-end">
              <button type="button" className="btn btn-secondary me-2" onClick={() => setpamentsModel(false)}>Cancel</button>
              <button
                className="btn btn-success"
                disabled={totalPayment <= 0 || totalPayment > parseFloat(Paymentvalue?.remaining || 0)}
                onClick={() => onHandlePayCredit(cashAmount, cardAmount)}
              >
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <OrderDetailsModal
        orders={selectedOrder}
        isOpen={isOrderModal}
        selectedOrder={selectedOrderData}
        items={selectedOrderItems}
        onClose={() => setOrderModal(false)}
        onRecordPayment={Handlepaymentmodel}
      />
    </>
  );
};

const OrderDetailsModal = ({ orders, isOpen, onClose, selectedOrder, items, onRecordPayment }) => {
  if (!isOpen || !selectedOrder) return null;

  const total = parseFloat(selectedOrder.grand_total !== undefined && selectedOrder.grand_total !== null ? selectedOrder.grand_total : selectedOrder.total || 0);
  const remaining = parseFloat(selectedOrder.remaining !== undefined ? selectedOrder.remaining : total);
  const paid = selectedOrder.purchase_unit === "1" || selectedOrder.purchase_unit === 1 ? total : (total - remaining);
  const status = remaining <= 0 ? "paid" : "unpaid";

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050, overflowY: "auto" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0 shadow-2xl rounded-2xl p-4 bg-white">
            <div className="modal-header border-0 pb-0 d-flex justify-content-between align-items-start">
              <div>
                <h4 className="modal-title fw-bold text-slate-800 tracking-tight" style={{ fontFamily: "Poppins" }}>
                  Item Purchase Details - {selectedOrder.po}
                </h4>
                <p className="text-xs text-slate-400 mt-1 font-medium text-start" style={{ fontFamily: "Poppins" }}>
                  View purchase information and payment history
                </p>
              </div>
              <button type="button" className="btn-close shadow-none" onClick={onClose} aria-label="Close"></button>
            </div>

            <div className="modal-body py-4 text-start" style={{ fontFamily: "Poppins" }}>
              <div className="row g-4 mb-4">
                <div className="col-6 col-md-3">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider block mb-1">Supplier</span>
                  <span className="text-sm font-semibold text-slate-700">{selectedOrder.supplier_name}</span>
                </div>
                <div className="col-6 col-md-3">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider block mb-1">Date</span>
                  <span className="text-sm font-semibold text-slate-700">{selectedOrder.date}</span>
                </div>
                <div className="col-6 col-md-3">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider block mb-1">PO Number</span>
                  <span className="text-sm font-semibold text-slate-700">{selectedOrder.lpo_no || "-"}</span>
                </div>
                <div className="col-6 col-md-3">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider block mb-1">Status</span>
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wide ${status === "paid" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                    {status}
                  </span>
                </div>
              </div>

              <div className="row g-3 mb-4 text-center align-items-stretch">
                <div className="col-6 col-md-3">
                  <div className="p-3 bg-slate-50 border border-slate-100 rounded-xl d-flex flex-column justify-content-center h-100 shadow-sm">
                    <span className="text-xs font-medium text-slate-400 block mb-1">Total Amount</span>
                    <strong className="text-base text-slate-700 font-bold">{total.toFixed(3)} INR</strong>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="p-3 bg-emerald-50/50 border border-emerald-100 rounded-xl d-flex flex-column justify-content-center h-100 shadow-sm">
                    <span className="text-xs font-medium text-slate-400 block mb-1">Total Paid</span>
                    <strong className="text-base text-emerald-600 font-bold">{paid.toFixed(3)} INR</strong>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="p-3 bg-purple-50/50 border border-purple-100 rounded-xl d-flex flex-column justify-content-center h-100 shadow-sm">
                    <span className="text-xs font-medium text-slate-400 block mb-1">Credit Tallied</span>
                    <strong className="text-base text-purple-600 font-bold">0.000 INR</strong>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="p-3 bg-orange-50/50 border border-orange-100 rounded-xl d-flex flex-column justify-content-center h-100 shadow-sm">
                    <span className="text-xs font-medium text-slate-400 block mb-1">Outstanding</span>
                    <strong className="text-base text-orange-600 font-bold">{remaining.toFixed(3)} INR</strong>
                  </div>
                </div>
              </div>

              {status !== "paid" && (
                <div className="d-flex justify-content-end mb-4">
                  <button
                    className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2.5 rounded-xl shadow-lg shadow-blue-100 font-semibold"
                    style={{ backgroundColor: "#004785", borderColor: "#004785" }}
                    onClick={() => {
                      onClose();
                      onRecordPayment(selectedOrder);
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>$</span>
                    Record Payment
                  </button>
                </div>
              )}

              <div className="text-start mb-4">
                <h5 className="fw-bold text-slate-800 mb-3 tracking-tight">Items Purchased</h5>
                {items && items.length > 0 ? (
                  <div className="table-responsive border border-slate-100 rounded-xl shadow-sm">
                    <table className="table table-align-middle text-center mb-0">
                      <thead className="table-light border-0">
                        <tr>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">#</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider text-start">Item Name</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Quantity</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Price (INR)</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Total (INR)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item, index) => (
                          <tr key={index} className="border-top border-slate-50">
                            <td className="py-2.5 text-sm font-semibold text-slate-500">{index + 1}</td>
                            <td className="py-2.5 text-sm text-slate-600 text-start">{item.product_name || "Unknown"}</td>
                            <td className="py-2.5 text-sm text-slate-600">{item.qty}</td>
                            <td className="py-2.5 text-sm text-slate-600">{parseFloat(item.unit_price || 0).toFixed(3)}</td>
                            <td className="py-2.5 text-sm font-bold text-slate-700">
                              {(parseFloat(item.qty || 0) * parseFloat(item.unit_price || 0)).toFixed(3)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="p-4 text-center bg-slate-50 rounded-xl border border-slate-100 text-sm text-slate-500">
                    No items found for this purchase
                  </div>
                )}
              </div>

              <div className="text-start">
                <h5 className="fw-bold text-slate-800 mb-3 tracking-tight">Payment History</h5>
                {orders && orders.filter(item => item.mop !== "2").length > 0 ? (
                  <div className="table-responsive border border-slate-100 rounded-xl shadow-sm">
                    <table className="table table-align-middle text-center mb-0">
                      <thead className="table-light border-0">
                        <tr>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">#</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">MOP</th>
                          <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Amount (INR)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders.filter(item => item.mop !== "2").map((item, index) => (
                          <tr key={index} className="border-top border-slate-50">
                            <td className="py-2.5 text-sm font-semibold text-slate-500">{index + 1}</td>
                            <td className="py-2.5 text-sm text-slate-600">{item.date}</td>
                            <td className="py-2.5 text-sm text-slate-600">
                              {item.mop === "1" ? "Cash" : item.mop === "4" ? "Card" : item.mop === "1,4" ? "Cash & Card" : "Other"}
                            </td>
                            <td className="py-2.5 text-sm font-bold text-slate-700">{parseFloat(item.amount || 0).toFixed(3)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="p-4 text-center bg-slate-50 rounded-xl border border-slate-100 text-sm text-slate-500">
                    No payment history found
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer border-0 pt-0 d-flex justify-content-end">
              <button type="button" className="btn btn-secondary px-4 py-2" onClick={onClose}>Close</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemPurchase;
